import React, { useState } from "react";

import { useTheme } from "@mui/material/styles";

import { Grid, IconButton, Tooltip, Typography } from "@mui/material";

import { Mode, logDebug } from "packable-components";
import { PackableAppContext } from "packable-components";
import { mergeProperties } from "packable-components";
import { SnackbarComponentVariant } from "packable-components";

import {
  IClientEntity,
  IItem,
  IUserAppState,
  Item,
  ItemDetails,
  ItemType,
  VoiceInput,
} from "packable-common";

import CreateIcon from "@mui/icons-material/Create";

const useStyles = (theme: any) => ({
  PackableAddItemBoxImage: {
    fontSize: "80px",
    color: theme.palette.primary.main,
  },
  PackableAddItemItemImage: {
    fontSize: "80px",
    color: theme.palette.primary.main,
  },
});

export interface AddItemProps {
  displayMessage: (variant: SnackbarComponentVariant, message: string) => void;
  setDisplaySpinner: (flag: boolean) => void;
  userAppState: IUserAppState;
  clientEntity: IClientEntity;
  windowWidth: number;
  windowHeight: number;
  styles?: any;
}

export const AddItem: React.FC<AddItemProps> = (props): React.JSX.Element => {
  const {
    displayMessage,
    setDisplaySpinner,
    userAppState,
    clientEntity,
    windowWidth,
    windowHeight,
    styles,
  } = props;
  const { httpService } = React.useContext(PackableAppContext);
  const [itemType, setItemType] = useState<ItemType | null>(null);
  const [isShowing, setIsShowing] = useState<boolean>(false);

  const theme = useTheme();

  logDebug("ViewItemDetails PROPS");
  logDebug(props);

  const defaultStyles = useStyles(theme);
  const effectiveStyles =
    styles === undefined
      ? defaultStyles
      : mergeProperties(defaultStyles, styles);

  logDebug("ViewItemDetails Effective Styles:");
  logDebug(effectiveStyles);

  const [item, setItem] = useState<IItem>(new Item());

  const onVoiceInputSubmit = (voiceInput: string): void => {
    processItemInput(voiceInput);
  };

  const onAddNewItemClose = (): void => {
    setIsShowing(false);
    setItemType(null);
  };

  const onItemTypeSelect = (itemType: ItemType): void => {
    setItemType(itemType);
    setIsShowing(true);
  };

  const processItemInputTextURL = "/input/item";
  const addTagURL = "/tag/create/inventory/";

  ///////////////////////
  //// API callbacks ////
  ///////////////////////
  const onProcessItemInputSuccess = (data: any) => {
    const item: IItem = data.data;
    setItem(item);
    setItemType(item.type);
    setIsShowing(true);
  };
  const onProcessItemInputError = (message: string, data: any) => {
    if (displayMessage) {
      displayMessage(SnackbarComponentVariant.error, message);
    }
  };
  ///////////////////////
  //// END API callbacks ////
  ///////////////////////

  ///////////////////
  //// API calls ////
  ///////////////////
  // process Item input
  const processItemInput = (voiceInputText: string) => {
    httpService.post(
      processItemInputTextURL,
      {
        inventoryId: userAppState.currentInventoryId,
        inputText: voiceInputText,
      },
      onProcessItemInputSuccess,
      onProcessItemInputError,
      setDisplaySpinner
    );
  };
  ///////////////////////
  //// END API calls ////
  ///////////////////////

  return (
    <div>
      <Grid>
        <Typography variant={"h6"}>Add Item</Typography>
      </Grid>
      {itemType === null && (
        <Grid
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            alignContent: "center",
            justifyContent: "center",
            alignItems: "center",
            [theme.breakpoints.up("sm")]: {
              justifyContent: "flex-start",
            },
          }}
        >
          {/*}
          <Grid sx={{ p: 1 }}>
            <Tooltip title="Add Packing Box to your inventory">
              <IconButton onClick={() => onItemTypeSelect(ItemType.BOX)}>
                <InventoryIcon
                  className="PackableAddItemBoxImage"
                  style={effectiveStyles.PackableAddItemBoxImage}
                />
              </IconButton>
            </Tooltip>
          </Grid>
          <Grid sx={{ p: 1 }}>
            <Tooltip title="Add Individual Item to your inventory">
              <IconButton onClick={() => onItemTypeSelect(ItemType.ITEM)}>
                <ChairIcon
                  className="PackableAddItemItemImage"
                  style={effectiveStyles.PackableAddItemItemImage}
                />
              </IconButton>
            </Tooltip>
          </Grid>
          {*/}
          <Grid sx={{ p: 1 }}>
            <VoiceInput
              title="Add Box"
              message="Describe your box including content, dimensions, weight and value"
              onInputSubmit={onVoiceInputSubmit}
              language={Intl.DateTimeFormat().resolvedOptions().locale}
              windowWidth={windowWidth}
              windowHeight={windowHeight}
            />
          </Grid>
          <Grid sx={{ p: 1 }}>
            <Tooltip title="Add Box to your inventory">
              <IconButton onClick={() => onItemTypeSelect(ItemType.BOX)}>
                <CreateIcon
                  className="PackableAddItemBoxImage"
                  style={effectiveStyles.PackableAddItemBoxImage}
                />
              </IconButton>
            </Tooltip>
          </Grid>
        </Grid>
      )}
      {isShowing && (
        <ItemDetails
          {...{
            isShowing: isShowing,
            onEntityDetailsClose: onAddNewItemClose,
            httpService: httpService,
            userAppState: userAppState,
            clientEntity: clientEntity,
            detailsMode: Mode.add,
            closeOnAdd: false,
            itemType: itemType,
            entityId: null,
            entity: item,
            entityName: "item",
            entityTitle: "Items",
            itemTitle: "Item",
            getItemURL: "/item",
            addURL: "/item",
            labelServiceURL: "/item_label/download",
            displayMessage: displayMessage,
            setDisplaySpinner: setDisplaySpinner,
            styles: effectiveStyles,
          }}
        />
      )}
    </div>
  );
};

export default AddItem;
